/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import moment from 'moment'
import TimePicker from 'rc-time-picker'
import _ from 'lodash'
import { Icon, Button, Radio, Header, Form, Modal } from 'semantic-ui-react'

import NameField from '../fields/nameField'
import OperationField from '../fields/operationField'
import MonthlyReportField from '../fields/monthlyReportField'
import OnlinePaymentField from '../fields/onlinePaymentField'
import PhoneField from '../fields/branchPhoneField'
import LocationField from '../fields/locationField'
import AddressField from '../fields/addressField'
import PayLaterField from '../fields/payLaterField'
import MerchantSettlementTypeField from '../fields/merchantSettlementTypeField'
import BankAccNameField from '../fields/bankAccountNameField'
import BankAccNumberField from '../fields/bankAccountNumberField'
import CommissionField from '../fields/commissionField'

export default class BranchForm extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      scheduleType: 'custom',
      initSchedules: props.branchData.schedules,
    }

    this.btnSubmitRef = React.createRef()
  }

  onScheduleTypeChange = (e, { value }) => {
    const { onFieldChange } = this.props
    const { initSchedules } = this.state

    this.setState({ scheduleType: value }, () => {
      onFieldChange('schedules', initSchedules)
    })
  }

  onScheduleChange = (day, fromOrTo, time) => {
    const { onFieldChange } = this.props
    const { branchData } = this.props
    let { schedules } = branchData

    let formattedTime = {}

    if (time) {
      formattedTime = time.format('HH:mm')
    } else {
      return
    }

    if (day !== 'all') {
      schedules = {
        ...schedules,
        [day]: {
          ...schedules[day],
          [fromOrTo]: formattedTime,
        },
      }

      onFieldChange('schedules', schedules)
    } else {
      let newSchedules = schedules

      _.map(schedules, (schedule, scheduleDay) => {
        newSchedules = {
          ...newSchedules,
          [scheduleDay]: {
            ...newSchedules[scheduleDay],
            [fromOrTo]: formattedTime,
          },
        }
      })

      onFieldChange('schedules', newSchedules)
    }
  }

  onSave = e => {
    const { saveBranch } = this.props
    e.preventDefault()

    saveBranch()
  }

  renderOneForAllDays = () => {
    const { branchData } = this.props

    const workingHour = branchData.schedules.monday

    return this.renderTimePicker('From', 'all', workingHour)
  }

  renderAllDays = () => {
    const { branchData } = this.props

    return (
      <React.Fragment>
        {this.renderTimePicker('Monday', 'monday', branchData.schedules.monday)}
        {this.renderTimePicker('Tuesday', 'tuesday', branchData.schedules.tuesday)}
        {this.renderTimePicker('Wednesday', 'wednesday', branchData.schedules.wednesday)}
        {this.renderTimePicker('Thursday', 'thursday', branchData.schedules.thursday)}
        {this.renderTimePicker('Friday', 'friday', branchData.schedules.friday)}
        {this.renderTimePicker('Saturday', 'saturday', branchData.schedules.saturday)}
        {this.renderTimePicker('Sunday', 'sunday', branchData.schedules.sunday)}
      </React.Fragment>
    )
  }

  renderTimePicker = (label, day, workingHour) => {
    return (
      <Form.Group inline>
        <label style={{ width: 80, marginRight: 0 }}>{label}</label>
        <TimePicker
          showSecond={false}
          value={moment(workingHour.from, 'HH:mm')}
          onChange={value => this.onScheduleChange(day, 'from', value)}
          format="h:mm a"
          use12Hours
          inputReadOnly
        />

        <label style={{ marginLeft: 10, marginRight: 10 }}>To</label>
        <TimePicker
          showSecond={false}
          value={moment(workingHour.to, 'HH:mm')}
          onChange={value => this.onScheduleChange(day, 'to', value)}
          format="h:mm a"
          use12Hours
          inputReadOnly
        />
      </Form.Group>
    )
  }

  render() {
    const { scheduleType } = this.state
    const { loading, onClose, visible, action, onFieldChange, branchData, permissions } = this.props
    const disabledCommission = action === 'edit' && !permissions.includes('edit_merchant_commission')

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Branch' : 'Edit Branch'} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <NameField onChange={onFieldChange} value={branchData.name} />
              <OperationField onChange={onFieldChange} value={branchData.operation_type} />
            </Form.Group>
            <Form.Group widths="equal">
              <PayLaterField onChange={onFieldChange} value={branchData.merchant_settlement} />
              <MerchantSettlementTypeField onChange={onFieldChange} value={branchData.merchant_settlement_type} />
            </Form.Group>
            <Form.Group widths="equal">
              <MonthlyReportField onChange={onFieldChange} value={branchData.monthly_report || false} />
              <OnlinePaymentField onChange={onFieldChange} value={branchData.accept_online_payment || false}/>
            </Form.Group>
            <Form.Group widths="equal">
              <BankAccNameField onChange={onFieldChange} value={branchData.aba_account_name } required={branchData.merchant_settlement} />
              <BankAccNumberField onChange={onFieldChange} value={branchData.aba_account_number} required={branchData.merchant_settlement} />
            </Form.Group>

            <Form.Group widths="equal">
              <LocationField
                onChange={onFieldChange}
                value={branchData.lat}
                field="lat"
                label="Lat"
              />
              <LocationField
                onChange={onFieldChange}
                value={branchData.lng}
                field="lng"
                label="Lng"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <CommissionField
                disabled={disabledCommission}
                onChange={onFieldChange}
                value={branchData.commission_rate}
                field='commission_rate'
              />
            </Form.Group>
            <Form.Group widths="equal">
              <PhoneField
                onChange={onFieldChange}
                value={branchData.order_phone}
                field="order_phone"
                label="Order Phone"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <PhoneField
                onChange={onFieldChange}
                value={branchData.manager_phone}
                field="manager_phone"
                label="Manager Phone"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <AddressField value={branchData.address} onChange={onFieldChange} />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Schedules</label>
                <Radio
                  label="All Day"
                  name="radioGroup"
                  value="all"
                  checked={scheduleType === 'all'}
                  onChange={this.onScheduleTypeChange}
                  style={{ marginRight: 10 }}
                />
                <Radio
                  label="Custom"
                  name="radioGroup"
                  value="custom"
                  checked={scheduleType === 'custom'}
                  onChange={this.onScheduleTypeChange}
                />
              </Form.Field>
            </Form.Group>
            {scheduleType === 'all' ? this.renderOneForAllDays() : this.renderAllDays()}
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/branchForm.js